import type { Course } from "./types";

export type Role = "auditor" | "student" | "guest";

export function emailTemplate(courses: Course[], lang: "bs" | "en", role: Role, name: string, intro: string) {
  const list = courses.map((c) => `„${c.name}“`).join(", ");
  const titles = courses.map((c) => c.name).join(", ");
  const me = name || (lang === "bs" ? "[Vaše ime]" : "[Your name]");
  if (lang === "bs") {
    const ask = {
      auditor: `da mi dozvolite da prisustvujem predavanjima iz predmeta ${list} kao slobodni slušalac, bez upisa i bez polaganja ispita`,
      student: `informacije o predmetu ${list} (termini, grupe i način rada u ovom semestru)`,
      guest: `da mi dozvolite da kao gost prisustvujem nekim predavanjima iz predmeta ${list}`,
    }[role];
    return {
      subject: role === "student" ? `Upit o predmetu: ${titles}` : `Molba za prisustvo predavanjima: ${titles}`,
      body: `Poštovani/a,\n\n${intro ? intro.trim() + "\n\n" : ""}obraćam Vam se s molbom ${role === "student" ? "za" : ""} ${ask}.\n\nMolim Vas da mi javite da li je to moguće, te da li su termini i sala za ovaj semestar potvrđeni.\n\nUnaprijed Vam zahvaljujem.\n\nS poštovanjem,\n${me}`.replace("molbom  ", "molbom "),
    };
  }
  const ask = {
    auditor: `whether I may attend the lectures of ${list} as an auditor, without enrolment and without taking exams`,
    student: `for information about ${list} (times, groups and how the course runs this semester)`,
    guest: `whether I may attend some lectures of ${list} as a guest`,
  }[role];
  return {
    subject: role === "student" ? `Question about ${titles}` : `Request to attend lectures: ${titles}`,
    body: `Dear Professor,\n\n${intro ? intro.trim() + "\n\n" : ""}I am writing to ask ${ask}.\n\nCould you let me know whether this is possible, and whether this semester's times and room are confirmed?\n\nThank you in advance.\n\nKind regards,\n${me}`,
  };
}

export const mailto = (emails: string[], t: { subject: string; body: string }) =>
  `mailto:${emails.join(",")}?subject=${encodeURIComponent(t.subject)}&body=${encodeURIComponent(t.body)}`;
